import { Tr, Td, useDisclosure, AccordionItem, AccordionButton, AccordionPanel, Radio, Flex, useToast } from '@chakra-ui/react'
import { Fragment } from 'react'
import { Input } from '../../../../../../components/Form'
import { FaEdit } from 'react-icons/fa'
import { Button } from '../../../../../../components/Button'
import { useForm } from 'react-hook-form'
import { useMutation, useQueryClient } from 'react-query'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { api } from '../../../../../../services/api'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

const schema = z.object({
  contato: z.string().nonempty('Campo obrigatório'),
  email: z.string().email('E-mail inválido').nonempty('Campo obrigatório'),
  celular: z.string().min(10, 'Celular inválido').nonempty('Campo obrigatório'),
  telefone: z.string().min(10, 'Telefone inválido').nonempty('Campo obrigatório'),
})

async function updateContatoCliente({ codigo_contato, nome_contato, email, celular, telefone, codigo_parceiro }) {
  const response = await api.put('/site/v2/orcamento-crm/atualiza-info-contato', {
    codigo_contato,
    nome_contato,
    email_contato: email,
    celular,
    telefone,
    codigo_parceiro,
  })

  return response.data
}

export function Item({ contato, isOdd, selectItem, isSelected }) {
  const { isOpen } = useDisclosure()
  const queryClient = useQueryClient()
  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true,
  })
  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: zodResolver(schema),
  })

  const { numeroProposta: numProposta } = useParams()

  const { mutateAsync: mutateUpdateContatoCliente, isLoading } = useMutation({
    mutationFn: updateContatoCliente,
    onSuccess: (data) => {
      console.log('data', data)
      queryClient.setQueryData(['items', numProposta], (oldData) => {
        return {
          ...oldData,
          informacao_da_proposta: {
            ...oldData.informacao_da_proposta,
            valida_proposta_nova: false,
            info_contato: oldData.informacao_da_proposta.info_contato.map((item) => {
              if (item.codigo_contato === data[0].codigo_contato) {
                console.log('entrou', item)
                return {
                  ...item,
                  nome_contato: data[0].nome_contato,
                  email_contato: data[0].email_contato,
                  celular: data[0].celular,
                  telefone: data[0].telefone,
                }
              }

              return item
            }),
          },
        }
      })

      toast({
        title: 'Contato atualizado com sucesso',
        status: 'success',
      })
    },
  })

  async function handleUpdateContatoCliente(data) {
    await mutateUpdateContatoCliente({
      codigo_contato: contato.codigo_contato,
      codigo_parceiro: contato.codigo_parceiro,
      nome_contato: data.contato,
      email: data.email,
      celular: data.celular,
      telefone: data.telefone,
    })
  }

  const handleRadioClick = (event) => {
    event.stopPropagation()
  }

  useEffect(() => {
    setValue('contato', contato.nome_contato)
    setValue('email', contato.email)
    setValue('celular', contato.celular)
    setValue('telefone', contato.telefone)
  }, [contato, setValue])

  return (
    <AccordionItem as={Fragment}>
      <Tr>
        <Td py={1} bgColor={isOdd ? '#EDF2F7' : 'white'}>
          <Radio onClick={handleRadioClick} size="lg" borderColor="#378BBF" isChecked={isSelected} z onChange={() => selectItem(contato)} />
        </Td>

        <Td py={1} bgColor={isOdd ? '#EDF2F7' : 'white'} textAlign="center">
          {contato.codigo_contato}
        </Td>
        <Td py={1} bgColor={isOdd ? '#EDF2F7' : 'white'}>
          {contato.nome_contato}
        </Td>
        <Td py={1} bgColor={isOdd ? '#EDF2F7' : 'white'}>
          {contato.email_contato}
        </Td>
        <Td py={1} bgColor={isOdd ? '#EDF2F7' : 'white'}>
          {contato.celular}
        </Td>
        <Td py={1} bgColor={isOdd ? '#EDF2F7' : 'white'}>
          {contato.telefone}
        </Td>
        <AccordionButton as={Td} py={1} in={isOpen} cursor="pointer" bgColor={isOdd ? '#EDF2F7' : 'white'}>
          <FaEdit size={20} color="#378BBF" />
        </AccordionButton>
      </Tr>

      <AccordionPanel as={Tr}>
        <Td colSpan={7}>
          <Flex flexDir="column" gap={1} maxW="350px" mx="auto" as="form" onSubmit={handleSubmit(handleUpdateContatoCliente)}>
            <Flex gap={2}>
              <Input label="Contato" id="contato" placeholder="digite o contato" flex={1} {...register('contato')} error={errors.contato} />
            </Flex>
            <Input label="E-mail" id="email" placeholder="digite o e-mail" {...register('email')} error={errors.email} />

            <Flex justifyContent="space-between">
              <Input label="Celular" id="celular" width="129px" placeholder="digite o celular" {...register('celular')} error={errors.celular} />
              <Input label="Telefone" id="telefone" width="129px" placeholder="digite o telefone" {...register('telefone')} error={errors.telefone} />
            </Flex>

            <Button maxW="176px" w="100%" mx="auto" color="white" mt={5} type="submit" isLoading={isLoading} loadingText="Atualizando...">
              Atualizar Contato
            </Button>
          </Flex>
        </Td>
      </AccordionPanel>
    </AccordionItem>
  )
}
